const Icon = (
	<svg
		focusable="false"
		viewBox="0 0 12 18"
		width="12"
		height="18"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<g>
			<path d="M2.641 18l.931-2.907h4.655L9.158 18h2.679L7.334 5.156H4.465L-.019 18h2.66zm4.978-4.959h-3.42l1.71-5.32 1.71 5.32zM5.416 4.08c.517 0 .925-.176 1.224-.528V4h.608V1.44C7.248.661 6.792.272 5.88.272c-.437 0-.776.084-1.016.252a.779.779 0 00-.36.668c0 .09.008.179.024.264h.568v-.208A.37.37 0 015.288.92c.128-.08.315-.12.56-.12.283 0 .48.053.592.16.112.107.168.27.168.488v.36l-.624.064c-1.115.117-1.672.51-1.672 1.176 0 .325.097.579.292.76.195.181.465.272.812.272zm.184-.512c-.427 0-.64-.184-.64-.552 0-.368.35-.6 1.048-.696l.6-.072v.872a1.325 1.325 0 01-1.008.448z" />
		</g>
	</svg>
);

export default Icon;
